'use client'

import { useEffect, useState } from 'react'
import { fetchTeamMembers, fetchTeamPageExperts } from '../../lib/teamApi'
import LeaderCards from '../team/LeaderCards'
import ExpertRoster from '../team/ExpertRoster'
import './home-v2.css'

// This section is the Team page's data rendered on the home page: the same two
// helpers (`fetchTeamMembers` / `fetchTeamPageExperts`), the same records, the
// same `image_url` for every person.
//
// It used to carry home-only overrides -- leaders capped at three, experts
// capped at ten with one name excluded, and a locally bundled cut-out portrait
// swapped in for each founder by name. Those made the two pages disagree about
// who is on the team and which photo belongs to whom (the Team page kept
// showing whatever the API returned, the home page showed something else), so
// the home page now renders the API records untouched.

// Certification marks, carried over from the previous CertificationsSection.
const CERTS = [
  { title: 'A2P Compliance', image: '/images/external/6809495041e8e478540a0fc9-c54ef416ef.png' },
  { title: 'Course Creator', image: '/images/external/6809495041e8e45bd10a0fc8-bcc4509b66.png' },
  { title: 'SaaSPRENEUR Local Hero', image: '/images/external/680949503e3c66b620e619d1-debc7d557d.png' },
  { title: 'AI Employee', image: '/images/external/680a7b4f4dd5ff729ab2a907-444b8a8aae.png' },
  { title: 'HIPAA Compliance', image: '/images/external/680a7b4f9269efa6bde5bf39-800bd47408.png' },
  { title: 'Paid Ads', image: '/images/external/680a7b4f8776df24f56abd1e-68f36bbb3b.png' },
]

export default function TeamV2() {
  const [leaders, setLeaders] = useState([])
  const [experts, setExperts] = useState([])

  // Identical to the Team page's fetch, so both pages always agree.
  useEffect(() => { fetchTeamMembers().then((list) => setLeaders(list || [])) }, [])
  useEffect(() => { fetchTeamPageExperts().then((list) => setExperts(list || [])) }, [])

  return (
    <section className="hv2 hv2-section is-tint">
      <div className="hv2-inner">
        <div className="hv2-head centered" data-rv="0.4">
          <span className="hv2-eyebrow">The people behind it</span>
          <h2>Meet <span className="hv2-hl">Your Mentors.</span></h2>
          <p>
            Our leaders bring years of experience building automation systems, CRM
            infrastructures, and AI-powered workflows for growth-focused businesses.
          </p>
        </div>

        <LeaderCards leaders={leaders} />
        <ExpertRoster experts={experts} />

        <div className="hv2-certs" data-rv="0.3" style={{ '--rv-y': '24px' }}>
          <p className="hv2-certs-label">Certifications</p>
          <p className="hv2-certs-lede">
            GHL Prime holds official GoHighLevel certifications. They include Certified Admin,
            the platform&rsquo;s highest certification. We also hold A2P Compliance, HIPAA
            Compliance, AI Employee, SaaS Mode and 7 more specializations.
          </p>
          <div className="hv2-certs-row">
            {CERTS.map((c) => (
              <span className="hv2-cert" key={c.title} title={c.title}>
                <img src={c.image} alt={c.title} loading="lazy" decoding="async" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
